export default __webpack_public_path__ + "static/media/vf-deleted.4312366c.svg";